<template>
	<div class="max-w-2xl mt-10 mx-auto px-4 sm:px-6 lg:px-8">

		<div v-if="hasPasted" :class="[doesClipboardContainGoogleElement ? 'bg-green-200' : 'bg-red-200']"
			 class="mb-4 p-4 rounded">
			<span v-if="hasPasted && doesClipboardContainGoogleElement">
				Valid paste! Processing now...
			</span>
			<span v-else>
				Paste is NOT valid!
			</span>
		</div>
		<div>
			<h3 class="text-lg leading-6 font-medium text-gray-900">Create New Icon</h3>
			<p class="mt-1 text-sm text-gray-500">Use this form to add a new icon to the database.</p>
		</div>

		<div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

			<div class="col-span-3 gap-y-6">
				<div class="sm:col-span-3">
					<label for="formalname" class="block text-sm font-medium text-gray-700"> Formal Name </label>
					<div class="mt-1">
						<input v-model="form.formalname" type="text" name="formalname" id="formalname"
							   class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"/>
					</div>
				</div>

				<div class="sm:col-span-3">
					<label for="shortname" class="block text-sm font-medium text-gray-700"> Short Name </label>
					<div class="mt-1">
						<input v-model="form.shortname" type="text" name="shortname" id="shortname"
							   class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"/>
					</div>
				</div>

				<div class="sm:col-span-3">
					<label for="color" class="block text-sm font-medium text-gray-700"> Color (HEX) </label>
					<div class="mt-1">
						<input v-model="form.color" type="text" name="color" id="color"
							   class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"/>
					</div>
				</div>
			</div>
			<div class="bg-white col-span-3 flex items-center justify-center m-4 rounded-2xl">
<!--				<svg-vue class="w-10 h-10" :icon="form.collection + '/' + props.dataProp.short_name"></svg-vue>-->
<!--				<inline-svg :src="'../images/icons/'  + props.dataProp.collection +'/'+ props.dataProp.short_name + '.svg'" class="w-10 h-10"></inline-svg>-->
				<inline-svg :src="'../svg-icons/missingIcons/' + props.dataProp.short_name + '.svg'" class="size-16"></inline-svg>
			</div>

			<div class="sm:col-span-6">
				<label for="description" class="block text-sm font-medium text-gray-700"> Description </label>
				<div class="mt-1">
					<textarea v-model="form.description" id="description" name="description" rows="3"
							  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"/>
				</div>
				<p class="mt-2 text-sm text-gray-500">OPTIONAL - add a description of this template.</p>
			</div>

			<div class="sm:col-span-6">
				<label for="collection" class="block text-sm font-medium text-gray-700">Collection</label>
				<select v-model="form.collection" id="collection" name="collection"
						class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
					<option >cssgg</option>
					<option>iconoir</option>
					<option>heroicons</option>
					<option selected="">featherIcons</option>
				</select>
			</div>

			<div class="sm:col-span-6">
				<label for="type" class="block text-sm font-medium text-gray-700">Template Type</label>
				<select v-model="form.type" id="type" name="type"
						class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
					<option selected="">icon</option>
					<option>slide-stub</option>
				</select>
			</div>

			<div class="sm:col-span-6">
				<label for="classification" class="block text-sm font-medium text-gray-700"> Classification </label>
				<div class="mt-1">
					<input v-model="form.classification" type="text" name="classification" id="classification"
						   class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"/>
				</div>
			</div>

		</div>
	</div>
</template>
<script setup>
import {useForm} from "@inertiajs/vue3";
import {computed, onMounted, ref} from "vue";
import { router } from '@inertiajs/vue3';
import InlineSvg from 'vue-inline-svg';

document.addEventListener('paste', function(e){

	const output = extractData(e.clipboardData)
		.then((response) => {
			// console.log(response.types)
			clipboard.value = response.types
			form.clipboard = response.types;
			return response.types
		})

	output.then((r) => {
		form.clipboard = [r]
		console.log(form.clipboard)
	});
	// console.log(Promise.resolve(output))

	hasPasted.value = true;
	submit(output);


});


const doesClipboardContainGoogleElement = computed(() => {
	let output = clipboard.value.filter(el => el.type.includes("application/x-vnd.google"));
	return output.length > 0;
})

async function extractData(data) {

	if (!data) {
		return undefined;
	}

	const file_info = file =>
		file
			? {
				name: file.name,
				size: file.size,
				type: file.type,
				url: URL.createObjectURL(file)
			}
			: null;

	if (data instanceof DataTransfer) {
		return {
			type: 'DataTransfer',
			types: Array.from(data.types).map(type => ({
				type,
				data: data.getData(type)
			})),
			items: data.items
				? Array.from(data.items).map(item => ({
					kind: item.kind,
					type: item.type,
					as_file: file_info(item.getAsFile())
				}))
				: null,
			files: data.files ? Array.from(data.files).map(file_info) : null
		};
	}

	if (data instanceof ClipboardItem) {
		return {
			type: 'ClipboardItem',
			types: await Promise.all(
				Array.from(data.types).map(async type => {
					const blob = await data.getType(type);
					return {
						type: type,
						data: blob.type.match(/^text\//)
							? await blob.text()
							: file_info(blob)
					};
				})
			)
		};
	}
	return undefined;
}


const clipboard = ref([]);
const hasPasted = ref(false);

const props = defineProps({
	dataProp: Object,
})

onMounted(() => {
		console.log("mounted");
		console.log(form.collection + '/' + props.dataProp.short_name);

		form.formalname = props.dataProp.formal_name,
		form.shortname = props.dataProp.short_name,
		form.description = props.dataProp.description,
		form.color = props.dataProp.color,
		form.collection = props.dataProp.collection,
		form.classification = props.dataProp.classification,
		form.type = props.dataProp.type,
		form.premium =  props.dataProp.premium,
		form.filepath = props.dataProp.file_path

})

const form = useForm({
	formalname: '',
	shortname: '',
	description: '',
	color: '',
	collection: '',
	clipboard: [],
	classification: '',
	type: 'icon',
	premium: false,
	filepath: ''
});

function submit(output) {


		output.then((result) => {

			let output = result.filter(el => el.type.includes("application/x-vnd.google"));
			if(output.length > 0) {

				form
					.transform((data) => ({
						...data,
						clipboard: [result],
					}))
					.post('/process', {
						onSuccess: () => {
							location.reload();
						}
					});

			}
		});


}

</script>